import { render } from "./PeopleToFollowUp.vue?vue&type=template&id=39429f78&scoped=true"
import script from "./PeopleToFollowUp.vue?vue&type=script&lang=js"
export * from "./PeopleToFollowUp.vue?vue&type=script&lang=js"

import "./PeopleToFollowUp.vue?vue&type=style&index=0&id=39429f78&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39429f78"]])

export default __exports__